import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4};
`;
